import { useQuery } from '@apollo/client';

import { AuthCurrentUserDocument, AuthCurrentUserQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useCurrentUserSberConnection = (): boolean => {
  const { data } = useQuery<AuthCurrentUserQuery>(AuthCurrentUserDocument, {
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
  });

  return data?.currentUserPureQuery?.sberBusinessClientInfo?.hasSberBusinessAccount ?? false;
};

export default useCurrentUserSberConnection;
